/** Affichage points / tier — priorité endpoint /loyalty (règle backend n°2). */

export function getStatusPoints(loyalty, customer) {
    if (loyalty?.statusPoints != null) return loyalty.statusPoints;
    return customer?.status_points ?? 0;
}

export function getPointsBalance(loyalty, customer) {
    if (loyalty?.pointsBalance != null) return loyalty.pointsBalance;
    return customer?.points_balance ?? getStatusPoints(loyalty, customer);
}

export function getTierLabel(loyalty, customer) {
    return loyalty?.currentTier?.name
        ?? customer?.loyalty_status_name
        ?? loyalty?.loyaltyStatus
        ?? customer?.loyalty_status
        ?? "–";
}
